// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Socials-List{margin-left:-8px;display:flex}.Socials-Link{display:flex;align-items:center;justify-content:center;width:44px;height:44px;transition:none}\n", ""]);
// Exports
module.exports = exports;
